import api from "../api/axiosConfig/axios";
import { SOCIAL_TOAST_KEY } from "../utils/GlobalConstants";
import { setCookie, deleteCookie, getCookie } from "./cookies.service";
import {
  updateAvatar,
  postUserDetils,
  Logout,
} from "../api/modules/b2droppie.class";

const API_URL = process.env.REACT_APP_API_URL;

const register = (payload) => {
  return api.post(API_URL + "/register", payload).then((response) => {
    if (response?.data?.user) {
      const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;

      deleteCookie("closed_local_promotion_banner");
      setCookie("user", JSON.stringify(response.data.user), expirationTime);

      localStorage.setItem("lastActivity", Date.now());
    }

    return response?.data;
  });
};

const login = (payload) => {
  return api.post(API_URL + "/login", payload).then((response) => {
    if (response?.data?.user) {
      const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;

      deleteCookie("closed_local_promotion_banner");
      setCookie("user", JSON.stringify(response.data.user), expirationTime);

      localStorage.setItem("lastActivity", Date.now());
    }

    return response?.data;
  });
};

const logout = async () => {
  try {
    deleteCookie("user");
    window.location.reload();
    await Logout();
  } catch (err) {
    console.warn("Logout API failed:", err);
  } finally {
    deleteCookie("user");
    deleteCookie("token");
    deleteCookie("closed_local_promotion_banner");

    sessionStorage.removeItem("freeBoxesRedirected");

    localStorage.removeItem(SOCIAL_TOAST_KEY);

    if (typeof window !== "undefined") {
      window.location.replace("/");
    }
  }
};

const updateUserAddress = (payload) => {
  return postUserDetils(payload).then((response) => {
    if (response?.data?.data) {
      const user = JSON.parse(getCookie("user"));
      const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;

      setCookie(
        "user",
        JSON.stringify({ ...user, address: response.data.data[0] }),
        expirationTime,
      );
    }
    return response;
  });
};

const updateUserAvatar = (payload) => {
  return updateAvatar(payload).then((response) => {
    if (response?.data?.data) {
      const user = JSON.parse(getCookie("user"));
      const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;

      setCookie(
        "user",
        JSON.stringify({ ...user, avatar: response.data.data }),
        expirationTime,
      );
    }
    return response;
  });
};

export default {
  register,
  login,
  logout,
  updateUserAddress,
  updateUserAvatar,
};
